import $ from 'jquery';
import modaal from 'modaal';
import * as CONST from '../utils/constants';

class Modal {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
		$('.js-inline-modal').modaal(
			{
				after_open: () => {
					if ($('.modaal-wrapper.modaal-inline').is(':visible') && $('.modaal-wrapper.modaal-inline').find('#ZipCodeLocation').length > 0) {
						$('.modaal-content-container').addClass('changeLocationCustom');
					}
				},
			}
		);

		$('.js-video').modaal({
			type: 'video',
			width: 920,
			after_open: () => {
				jQuery('#modaal-close').detach().appendTo('.modaal-video-container');
			}
		});

		$('.image-modal').modaal({
			type: 'image',
			width: 930
		});
    }
}

export default Modal;

$(() => {
	const modal = new Modal();
	modal.init();
});